import Axios from 'axios';
import qs from 'qs';
import { Storage } from '../../service/core/storage';
import { Navigate } from '../../assets/utils/navigate';
import { Message } from 'element-ui';

export class Http {

  httpClient;

  get token() {
    return Storage.get('token');
  }

  get baseUrl() {
    return 'https://api.goodyiyao.cn/index.php/api';
    // return 'https://api.goodyiyao.cn/index.php/api';
    // return process.env.NODE_ENV === 'production'? AppConfig.productionURL: AppConfig.developmentURL;
  }

  constructor(baseUrl) {
    this.httpClient = Axios.create({
      baseURL: baseUrl || this.baseUrl,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
    });
  }

  post(url, data = {}, headers) {
    return new Promise((resolve, reject) => {
      this.deleteEmptyString(data);
      data.access_token = this.token;
      this.httpClient.post(url, qs.stringify(data), { headers }).then((response) => {
        const result = this.parse(response.data);
        if (response.status === 200 && result.errcode === 0) {
          resolve(result.data);
          if(result.msg) { Message.success({ message: result.msg, customClass: 'messageClass' }); }
        } else {
          this.unifyError(reject, url)(response.data);
        }
      }).catch(this.unifyError(reject, url));
    });
  }

  upload(url, data = {}, headers = { 'content-type': 'multipart/form-data' }) {
    return new Promise((resolve, reject) => {
      this.deleteEmptyString(data);
      data.access_token = this.token;
      const formData = new FormData();
      for(let key of Object.keys(data)) {
        formData.set(key, data[key]);
      }
      this.httpClient.post(url, formData, { headers }).then((response) => {
        const result = this.parse(response.data);
        if (response.status === 200 && result.state === 'SUCCESS') {
          resolve(result);
        } else {
          this.unifyError(reject, url)({ msg: result.state });
        }
      }).catch(this.unifyError(reject, url));
    });
  }

  get(url, data = {}) {
    return new Promise((resolve, reject) => {
      this.deleteEmptyString(data);
      data.access_token = this.token;
      const queryParams = this.objectToUrlString(data || {});
      this.httpClient.get(`${url}${queryParams? '?' + queryParams: ''}`).then((response) => {
        const result = this.parse(response.data);
        // if (response.status === 200 && (result.errcode === 0 || result.state === 'SUCCESS')) {
        if (response.status === 200) {
          resolve(this.parse({data: result.data, originalData: result}));
        } else {
          this.unifyError(reject, url)(response.data);
        }
      }).catch(this.unifyError(reject, url));
    });
  }

  // 以下方法属于工具函数

  unifyError(reject, url) {
    return (error) => {
      Message.error({ message: error.msg, customClass: 'messageClass' });
      if ((error.errcode === 10001) && url !== '/login') {
        Navigate.route.replace('/login');
      }
      reject(error);
      // console.log(error, url);
    };
  }

  parse(data) {
    return typeof data === 'string'? JSON.parse(data): data;
  }

  deleteEmptyString(data) {
    for (const key of Object.keys(data)) {
      if (data[key] === '') {
        delete data[key];
      }
    }
  }

  objectToUrlString = (obj, encode = false) => {
    const result = [];
    for (const item in obj) {
      result.push(`${item}=${encode? encodeURIComponent(obj[item]): obj[item]}`);
    }
    return result.join('&');
  }

}
